import { render, staticRenderFns } from "./CountingDetailQuery.vue?vue&type=template&id=20b1a6b5"
import script from "./CountingDetailQuery.vue?vue&type=script&lang=js"
export * from "./CountingDetailQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports